import type { StatisticCardConfig } from "@ms/shared-components";

/**
 * 统计数据配置
 * 用于生成统计卡片的配置数据
 */
export const createStatisticData = (statistics: {
  total: number;
  buildings: number;
  zones: number;
  spaces: number;
}): StatisticCardConfig[] => [
  {
    key: "total",
    title: "总空间数",
    value: statistics.total,
    iconKey: "ClusterOutlined",
    valueStyle: { color: "#1890ff" },
  },
  {
    key: "buildings",
    title: "建筑数量",
    value: statistics.buildings,
    iconKey: "ApiOutlined",
    valueStyle: { color: "#52c41a" },
  },
  {
    key: "zones",
    title: "区域数量",
    value: statistics.zones,
    iconKey: "FileTextOutlined",
    valueStyle: { color: "#faad14" },
  },
  {
    key: "spaces",
    title: "空间数量",
    value: statistics.spaces,
    iconKey: "KeyOutlined",
    valueStyle: { color: "#f5222d" },
  },
];
